import React, { useState } from 'react';
import './MarineAreas.scss';
import LeafletMap from '../common/Leaflet';
import flechaSvg from '../../assets/flecha.svg';

import ParqueMarinoElArenal from '../common/geoJson/ParqueMarinoElArenal.json';
import ParqueMarinoElPalillo from '../common/geoJson/ParqueMarinoElPalillo.json';
import ParqueMarinoLoberia from '../common/geoJson/ParqueMarinoLoberia.json';
import ParqueMarinoMontesSUbmarinosCruseoYSelkirk from '../common/geoJson/ParqueMarinoMontesSubmarinosCruseoYSelKirk.json';
import ParqueMarinoMotuMotiroHiva from '../common/geoJson/ParqueMarinoMotuMotiroHiva.json';
import ParqueMarinoNazcaDesventurada from '../common/geoJson/ParqueMarinoNazcaDesventurada.json';
import ParqueMarinoTierraBlanca from '../common/geoJson/ParqueMarinoTierraBlanca.json';
import ReservaMarinaIslasChanaral from '../common/geoJson/ReservaMarinaIslaCHanaral.json';
import ReserveMarinaIslasChoros from '../common/geoJson/ReservaMarinaIslasChorosYDamas.json';
import ReservaMarinaLaRinconada from '../common/geoJson/ReservaMarinaLaRinconadaDN.json';
import ReservaMarinaPetemun from '../common/geoJson/ReservaMarinaPetemun.json';
import ReservaMarinaPulliquen from '../common/geoJson/ReservaMarinaPullinque.json';
import AmerbDamasDecretoExento from '../common/geoJson/AmerbDamasDecretoExento.json';
import FranciscoColane from '../common/geoJson/FranciscoColane.json';
import JuanFernandez from '../common/geoJson/JuanFernandez.json';
import IslasDiegoRamirez from '../common/geoJson/islas_diego_ramirez.json';

const MarineAreas = () => {
    /**
     * Vista de Areas Protegidas
     * Carga un mapa con las areas protegidas y direfentes urls
     */
    const [markerPosition, setMarkerPosition] = useState({ lat: -33.439269, lng: -70.646881 });
    const [zoom, setZoom] = useState(5);
    const [zoomconmutator, setZoomconmutator] = useState(false);
    const [dynamicData, setDynamicData] = useState(null);
    const [showDropdown, setShowDropdown] = useState(true);
    const panTo = (geoJson) => {
        setZoom(10);
        setZoomconmutator(!zoomconmutator);
        setMarkerPosition({ lat: geoJson.markerPosition[0], lng: geoJson.markerPosition[1], legend: geoJson.name });
        setDynamicData(geoJson);
    }

    return (
        <div className="MarineAreasMasterContainer">
            <div className="textContentContainer">
                <span className="textContentTitle">Áreas marinas protegidas</span>
                <span className="textContentContent">Son áreas delimitadas y definidas geográficamente cuya administración y regulación permiten alcanzar objetivos específicos de conservación y/o preservación.</span>
                <span className="textContentContent">En nuestro país existen cuatro tipos de AMP: los parques marinos y las reservas marinas, que son esencialmente acuáticas; y los santuarios de la naturaleza y las áreas marinas y costeras protegidas de múltiples usos, que pueden contener porciones de tierra. Todas son decretadas por el Ministerio de Medio Ambiente, pero en el caso de las dos primeras, es la Subsecretaría de Pesca y Acuicultura la encargada de proveer los antecedentes para su destinación, quedando la tuición en manos del Servicio Nacional de Pesca y Acuicultura.</span>
            </div>

            <div className="mapContainer">
                <div className="optionsContainer">
                    <button onClick={() => { setShowDropdown(showDropdown => !showDropdown); }} className="optionsTitle">
                        <span>
                            Lista De Parques Marinos De Chile
                        </span>
                        <img src={flechaSvg} alt="" /></button>

                    <div className={(showDropdown === true ? "dropdownVisible" : "dropdownHidden") + " dropdownContainer"}>
                        <span onClick={() => { panTo(ParqueMarinoElArenal); setShowDropdown(false); }} className="option">Parque marino El arenal D.S</span>
                        <span onClick={() => { panTo(ParqueMarinoElPalillo); setShowDropdown(false); }} className="option">Parque marino El Palillo D.S</span>
                        <span onClick={() => { panTo(ParqueMarinoLoberia); setShowDropdown(false); }} className="option">Parque marino Loberia SELKIRK D.S</span>
                        <span onClick={() => { panTo(JuanFernandez); setShowDropdown(false); }} className="option">Parque marino Mar de Juan Fernandez</span>
                        <span onClick={() => { panTo(ParqueMarinoMontesSUbmarinosCruseoYSelkirk); setShowDropdown(false); }} className="option">Parque marino Montes Submarinos Crusoe y Selkirk D.S</span>
                        <span onClick={() => { panTo(ParqueMarinoTierraBlanca); setShowDropdown(false); }} className="option">Parque marino Tierra Blanca D.S</span>
                        <span onClick={() => { panTo(FranciscoColane); setShowDropdown(false); }} className="option">Parque marino Francisco Coloane DN276-2003</span>
                        <span onClick={() => { panTo(ParqueMarinoMotuMotiroHiva); setShowDropdown(false); }} className="option">Parque marino Motu Motiro Hiva DSN 235 2010</span>
                        <span onClick={() => { panTo(ParqueMarinoNazcaDesventurada); setShowDropdown(false); }} className="option">Parque marino Nazca Desventurada DSN 05-2016</span>
                        <span onClick={() => { panTo(AmerbDamasDecretoExento); setShowDropdown(false); }} className="option">Amerb Damas Decreto Exento N408-2005</span>
                        <span onClick={() => { panTo(ReservaMarinaPulliquen); setShowDropdown(false); }} className="option">Reserva Marina Pullinque DN133-2003</span>
                        <span onClick={() => { panTo(ReservaMarinaIslasChanaral); setShowDropdown(false); }} className="option">Reserva marina Isla Chanaral DN 150-2005 - DN 161-2010</span>
                        <span onClick={() => { panTo(ReserveMarinaIslasChoros); setShowDropdown(false); }} className="option">Reserva Marina Islas Chorosy Damas DN151-2005 N161-2010</span>
                        <span onClick={() => { panTo(ReservaMarinaLaRinconada); setShowDropdown(false); }} className="option">Reserva Marina La Rinconada DN522-1997</span>
                        <span onClick={() => { panTo(ReservaMarinaPetemun); setShowDropdown(false); }} className="option">Reserva Marina Putemun DN134-2003</span>
                        <span onClick={() => { panTo(IslasDiegoRamirez); setShowDropdown(false); }} className="option">Parque marino Islas Diego Ramírez y Paso Drake</span>
                    </div>

                </div>

                <div className="leafletContainer">
                    <LeafletMap zoomConmutator={zoomconmutator} className="LeafletMap" zoom={zoom} dynamicPopup={dynamicData} />
                </div>
            </div>

            <div className="bannerPhohibidoContainer">
                <span>
                    Recuerda que está prohibido pescar en zonas de área marina protegidas
                </span>
            </div>
        </div>
    )
}

export default MarineAreas;